import React, { useContext, useEffect, useState } from "react"; // eslint-disable-line no-unused-vars
import { useTheme } from "@material-ui/core/styles";
import {
  Grid,
  Typography,
  Paper,
  Button,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Link,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  useMediaQuery,
  Hidden,
} from "@material-ui/core";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import * as consts from "../../consts";

export default function CardType(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [showExample, setShowExample] = useState(0);

  const renderEmailOptions = () => {
    return (
      <FormControl className={props.classes.cardtypeform}>
        <Typography
          variant="body1"
          component="div"
          className={props.classes.cardtypeemailOptions}
        >
          Choose a date to send an email to your gift recipients or leave the
          delivery date set to today and we'll send your gift as soon as your
          transaction is completed.
        </Typography>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <KeyboardDatePicker
            className={props.classes.cardtypeemailInputs}
            margin="none"
            label="Delivery Date"
            openTo="month"
            views={["year", "month", "date"]}
            format="MM/dd/yyyy"
            value={props.deliveryDate}
            onChange={(date) => {
              props.onDeliveryDateChanged(date);
            }}
          />
        </MuiPickersUtilsProvider>
      </FormControl>
    );
  };

  const renderPlasticOptions = () => {
    return (
      <FormControl className={props.classes.cardtypeform}>
        <Typography
          variant="body1"
          component="div"
          className={props.classes.cardtypeplasticOptions}
        >
          Mail biodegradable plastic charity gift cards to yourself or directly
          to your recipients. A production cost of $3.29 each helps cover the
          cost of the plastic gift card, greeting card, envelope, shipping, and
          handling.
        </Typography>
        <RadioGroup
          aria-label="Mail options"
          name="mailOption"
          value={props.mailOption}
          onChange={(event) => {
            props.onMailOptionChanged(event.target.value);
          }}
        >
          <FormControlLabel
            value={consts.PLASTIC_TYPE_ME}
            control={<Radio />}
            label="Mail to me"
          />
          <FormControlLabel
            value={consts.PLASTIC_TYPE_THEM}
            control={<Radio />}
            label="Mail to recipient"
          />
        </RadioGroup>
      </FormControl>
    );
  };

  const renderPrinterOptions = () => {
    return (
      <FormControl className={props.classes.cardtypeform}>
        <Typography
          variant="body1"
          component="div"
          className={props.classes.cardtypeprintOptions}
        >
          Download a PDF card to either print or send digitally.
          <ul>
            <li>Print on letter-sized paper</li>
            <li>Send via email or your favorite messaging app</li>
          </ul>
        </Typography>
      </FormControl>
    );
  };

  const renderSample = () => {
    return (
      <Dialog
        fullScreen={fullScreen}
        open={showExample > 0}
        onClose={() => {
          setShowExample(0);
        }}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          <Typography variant="h5" color="primary">
            {showExample == 1 ? "Digital Card Example" : null}
            {showExample == 2 ? "Printer Card Example" : null}
            {showExample == 3 ? "Plastic Card Example" : null}
          </Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            className={props.classes.cardtypeexampleContainter}
          >
            {showExample == 1 ? (
              <img
                className={props.classes.cardtypeexample}
                src={`${consts.BLOB_URL}images/EmailExample.png`}
                alt="Digital Card Example"
              />
            ) : null}
            {showExample == 2 ? (
              <img
                className={props.classes.cardtypeexample}
                src={`${consts.BLOB_URL}images/PrinterExample.png`}
                alt="Printer Card Example"
              />
            ) : null}
            {showExample == 3 ? (
              <img
                className={props.classes.cardtypeexample}
                src={`${consts.BLOB_URL}images/PlasticExample.jpg`}
                alt="Plastic Card Example"
              />
            ) : null}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setShowExample(showExample > 1 ? showExample - 1 : 3);
            }}
            color="primary"
            variant="contained"
          >
            Previous
          </Button>
          <Button
            onClick={() => {
              setShowExample(showExample < 3 ? showExample + 1 : 1);
            }}
            color="primary"
            variant="contained"
          >
            Next
          </Button>
          <Button
            onClick={() => {
              setShowExample(0);
            }}
            color="primary"
            variant="contained"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  return (
    <Grid item container xs={12} className={props.classes.cardtypemain}>
      {renderSample()}
      <Grid item xs={12}>
        <Typography
          variant="h5"
          color="primary"
          className={props.classes.cardtypetitle}
        >
          Card Type
        </Typography>
        <Hidden xsDown={true}>
          <Button
            variant="outlined"
            color="secondary"
            className={props.classes.cardtypetoggle}
            onClick={() => {
              setShowExample(1);
            }}
          >
            View Examples
          </Button>
        </Hidden>
      </Grid>
      <Hidden smUp={true}>
        <Grid item xs={12}>
          <Button
            variant="outlined"
            color="secondary"
            fullWidth={true}
            className={props.classes.cardtypetogglefull}
            onClick={() => {
              setShowExample(1);
            }}
          >
            View Examples
          </Button>
        </Grid>
      </Hidden>
      <Grid item container xs={12} className={props.classes.cardtypeoptions}>
        <Grid item xs={12} sm={4}>
          <Paper
            className={
              props.cardType == consts.CARD_TYPE_EMAIL
                ? " " + props.classes.cardtypeselectedOption
                : props.classes.cardtypeoption
            }
            onClick={() => {
              props.onCardTypeChanged(consts.CARD_TYPE_EMAIL);
            }}
          >
            <img
              src={`${consts.BLOB_URL}images/cardtypeemail.png`}
              alt="Digital Card Icon"
              className={props.classes.cardtypeiconNudge}
            />
            <Typography variant="h6">Digital</Typography>
          </Paper>
          <Hidden smUp={true}>
            <Grid item xs={12} className={props.classes.cardtypedetails}>
              {props.cardType == consts.CARD_TYPE_EMAIL && renderEmailOptions()}
            </Grid>
          </Hidden>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Paper
            className={
              props.cardType == consts.CARD_TYPE_PRINTER
                ? " " + props.classes.cardtypeselectedOption
                : props.classes.cardtypeoption
            }
            onClick={() => {
              props.onCardTypeChanged(consts.CARD_TYPE_PRINTER);
            }}
          >
            <img
              src={`${consts.BLOB_URL}images/cardtypeprinter.png`}
              alt="Printer Card Icon"
            />
            <Typography variant="h6">Printer</Typography>
          </Paper>
          <Hidden smUp={true}>
            <Grid item xs={12} className={props.classes.cardtypedetails}>
              {props.cardType == consts.CARD_TYPE_PRINTER &&
                renderPrinterOptions()}
            </Grid>
          </Hidden>
        </Grid>
        <Grid item xs={12} sm={4}>
          <Paper
            className={
              props.cardType == consts.CARD_TYPE_PLASTIC
                ? " " + props.classes.cardtypeselectedOption
                : props.classes.cardtypeoption
            }
            onClick={() => {
              props.onCardTypeChanged(consts.CARD_TYPE_PLASTIC);
            }}
          >
            <img
              src={`${consts.BLOB_URL}images/cardtypeplastic.png`}
              alt="Plastic Card Icon"
            />
            <Typography variant="h6">Plastic</Typography>
          </Paper>
          <Hidden smUp={true}>
            <Grid item xs={12} className={props.classes.cardtypedetails}>
              {props.cardType == consts.CARD_TYPE_PLASTIC &&
                renderPlasticOptions()}
            </Grid>
          </Hidden>
        </Grid>
      </Grid>
      <Hidden xsDown={true}>
        <Grid item xs={12} className={props.classes.cardtypedetails}>
          {props.cardType == consts.CARD_TYPE_PLASTIC && renderPlasticOptions()}
          {props.cardType == consts.CARD_TYPE_EMAIL && renderEmailOptions()}
          {props.cardType == consts.CARD_TYPE_PRINTER && renderPrinterOptions()}
        </Grid>
      </Hidden>
    </Grid>
  );
}
